const MOBILE_BREAKPOINT = 375;
const TABLET_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1200;
const LARGE_DESKTOP = 1600;

export { DESKTOP_BREAKPOINT, LARGE_DESKTOP, MOBILE_BREAKPOINT, TABLET_BREAKPOINT };
